import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { AppService } from '../../../../../services';
import { StaffEngagementCountsWidget, StaffEngagementRow } from '../../../../../ui/widget/shared-tab-counts-table/staff-engagement-counts/staff-engagement-counts.widget';
import { VolunteeringAreaService } from '../../../volunteering-area.service';

@Component({
	selector: 'volunteering-specialists-tab-2-part',
	standalone: true,
	imports: [StaffEngagementCountsWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-specialists-tab-2.part.html',
})

export class VolunteeringSpecialistsTab2Part {

	private areaService = inject(VolunteeringAreaService);
	private app = inject(AppService);

	public staffEngagementData = computed(() => {
		const data = this.areaService.volunteeringData();
		if (!data) return [];

		// Filter volunteers to Specialists only (not mentors, but in-class or office hours)
		const volunteers = data.volunteers.filter(v =>
			!v.isMentorApproved && (v.isInClassApproved || v.isOfficeHoursApproved)
		);

		// Group by staff
		const staffMap = new Map<number, { engagedCount: number; assignedCount: number }>();

		volunteers.forEach(volunteer => {
			// Count engaged (lastContactStaffId)
			if (volunteer.lastContactStaffId) {
				const engagedData = staffMap.get(volunteer.lastContactStaffId) || { engagedCount: 0, assignedCount: 0 };
				engagedData.engagedCount++;
				staffMap.set(volunteer.lastContactStaffId, engagedData);
			}

			// Count assigned (assignedToStaffId)
			if (volunteer.assignedToStaffId) {
				const assignedData = staffMap.get(volunteer.assignedToStaffId) || { engagedCount: 0, assignedCount: 0 };
				assignedData.assignedCount++;
				staffMap.set(volunteer.assignedToStaffId, assignedData);
			}
		});

		// Convert to array format
		const staffEngagementRows: StaffEngagementRow[] = [];
		staffMap.forEach((counts, staffId) => {
			const staffName = this.app.getStaffNameById(staffId) || 'Unknown Staff';
			staffEngagementRows.push({
				staffId,
				staffName,
				engagedCount: counts.engagedCount,
				assignedCount: counts.assignedCount
			});
		});

		// Sort by staff name
		return staffEngagementRows.sort((a, b) => a.staffName.localeCompare(b.staffName));
	});

}
